export default __webpack_public_path__ + "static/squarestick-0875f76562b327c82f69885ff33f11c1.png";